(function($) {

    $.fn.lateSelect = function() {

        this.each( function() {
            var lateselect_html = '';
            var all_items = '';
            var selected_items = '';
            var is_selected = '';
            $(this).hide();
            $(this).find('option').each(function(){
                if($(this).is(':selected')) selected_items+= '<div class="ls-item" data-value="' + $(this).val() + '"><span>' + $(this).text() + '</span><span class="latepoint-icon latepoint-icon-x ls-item-remover"></span></div>';
                is_selected = $(this).is(':selected') ? 'selected' : '';
                all_items+= '<div class="ls-item '+ is_selected +'" data-value="' + $(this).val() + '">' + $(this).text() + '</div>';
            });
            lateselect_html = $('<div class="lateselect-w"></div>');
            $(this).wrap(lateselect_html);
            var $lateselect_wrapper = $(this).closest('.lateselect-w');
            $lateselect_wrapper.append('<div class="ls-selected-items-w">' + selected_items + '</div>');
            $lateselect_wrapper.append('<div class="ls-all-items-w">' + all_items + '</div>');


            // ADD ITEM
            $lateselect_wrapper.on('click', '.ls-all-items-w .ls-item:not(.selected)', function(){
                var selected_value = $(this).data('value');
                $lateselect_wrapper.find('.ls-selected-items-w').append('<div class="ls-item" data-value="' + selected_value + '"><span>' + $(this).text() + '</span><span class="latepoint-icon latepoint-icon-x ls-item-remover"></span></div>');
                $(this).addClass('selected');
                $lateselect_wrapper.removeClass('ls-selecting');
                $lateselect_wrapper.find('select option[value="'+ selected_value +'"]').attr('selected', true);
                $lateselect_wrapper.find('select').trigger('change');
                return false;
            });

            // REMOVE ITEM
            $lateselect_wrapper.on('click', '.ls-selected-items-w .ls-item-remover', function(){
                var selected_value = $(this).closest('.ls-item').data('value');
                $(this).closest('.ls-item').remove();
                $lateselect_wrapper.find('.ls-all-items-w .ls-item.selected[data-value="' + selected_value + '"]').removeClass('selected');
                $lateselect_wrapper.find('select option[value="'+ selected_value +'"]').removeAttr('selected');
                $lateselect_wrapper.find('select').trigger('change');
                return false;
            });

            $lateselect_wrapper.on('click', '.ls-selected-items-w', function(){
                $lateselect_wrapper.toggleClass('ls-selecting');
                return false;
            });
        });
    }
}(jQuery));